function _getStorage() {
    const storage = window.localStorage
    if(!storage)
        throw `Can't use local storage`
    let x = '__storage_test__'
    storage.setItem(x, x)
    if(storage.getItem(x) !== x)
        throw `Can't use local storage`
    storage.removeItem(x)
    if(storage.getItem(x) !== null)
        throw `Can't use local storage`
    return storage
}

export default class Settings {
    get CLASS() { return 'Settings' }
    get TITLE() {
        return `${this._name}`
    }
    get NAME() {
        return `${this._app}-${this._name}-settings`
    }
    constructor(options={}, values={}, app='app', name='sett', check=false) {
        this._app = app
        this._name = name
        this._options = options
        this._setAll(values, check)
    }
    _check(name, value=undefined) {
        const opt = this._options[name]
        if(!opt)
            throw `Option "${name}" does not exist`
        if(value === undefined && !opt.required)
            return undefined
        if(value === undefined &&  opt.required)
            throw `Value for "${name}" is required`
        const type = opt.type ? opt.type.name.toLowerCase() : undefined
        if(
            type &&
            (typeof value !== 'object' && type !== typeof value ||
            typeof value === 'object' && type !== 'array')
        )
            throw `Invalid type "${typeof value}" for "${name}"`
        if(opt.enum && opt.enum.indexOf(value) < 0)
            throw `Value for "${name}" does not belong to enum`
        if(opt.validator && !opt.validator(value, this))
            throw opt.txtError ? opt.txtError : `Invalid value for "${name}"`
        return value
    }
    _set(name, value=undefined, check=true) {
        const opt = this._options[name]
        if(check)
            value = this._check(name, value)
        if(value === undefined && opt.default) {
            value = opt.default(value, this)
            if(check)
                value = this._check(name, value)
        }
        if(this[name] && opt.type === Array) // For Vue.js reactivity system
            this[name].splice(0, this[name].length, ...value)
        else
            this[name] = value
        return value
    }
    _setDefault(name, check=true) {
        return this._set(name, undefined, check)
    }
    _setAll(values={}, check=true) {
        Object.keys(this._options).forEach(name => {
            this._set(name, values[name], check)
        })
    }
    _add(name, value) {
        const opt = this._options[name]
        if(!this[name] || opt.type !== Array)
            throw `Can not add ${name} to non array`
        this[name].push(value)
    }
    _copy(onlyEditable=false) {
        let values = {}
        Object.keys(this._options)
            .filter(name => !onlyEditable || this._isEditable(name))
            .forEach(name => {values[name] = this[name]})
        return values
    }
    _copyEditable() {
        return this._copy(true)
    }
    _isBoolean(name) {
        const opt = this._options[name]
        return opt && opt.type === Boolean ? true : false
    }
    _isNumber(name) {
        const opt = this._options[name]
        return opt && opt.type === Number ? true : false
    }
    _isString(name) {
        const opt = this._options[name]
        return opt && opt.type === String ? true : false
    }
    _isArray(name) {
        const opt = this._options[name]
        return opt && opt.type === Array ? true : false
    }
    _isEnum(name) {
        const opt = this._options[name]
        return opt && opt.enum && opt.enum.length ? true : false
    }
    _isInEnum(name, value) {
        const opt = this._options[name]
        return this._isEnum(name) && opt.enum.indexOf(value) >= 0
    }
    _isRequired(name) {
        const opt = this._options[name]
        return opt && opt.required ? true : false
    }
    _isValid(name) {
        const opt = this._options[name]
        if(opt && (!opt.validator || opt.validator(this[name], this)))
            return true
        return false
    }
    _isEditable(name) {
        const opt = this._options[name]
        if(opt && (!opt.editable || opt.editable(this[name], this)))
            return true
        return false
    }
    _isEnabled(name) {
        const opt = this._options[name]
        if(opt && (!opt.enabled || opt.enabled(this[name], this)))
            return true
        return false
    }
    _typeDefine(name) {
        const opt = this._options[name]
        const val = this[name]
        if(opt && opt.type)
            return opt.type.name.toLowerCase()
        if(val === null || val === undefined)
            return 'string'
        else
            return typeof val
    }
    _save() {
        _getStorage().setItem(this.NAME, JSON.stringify(this._copyEditable()))
    }
    _load(check=true) {
        this._setAll(JSON.parse(_getStorage().getItem(this.NAME)), check)
    }
}

const SettingsEx = {
    // Name of the option that can be accessed as
    // Settings.variable or Settings[variable]
    variable: {
        name: 'My var',            // Name to display in GUI
        type: String,              // Type: one of
                                   // [Number, Boolean, String, Array, Object]
        enum: ['a', 'b'],          // Possible values (or undefined)
        txtDescr: 'This is..',     // Long description for GUI
        txtEditable: 'Can not',    //  Text for non editable options
        txtEnable: 'Set before..', //  Text for non enabled options
        txtError: 'Incorrect..',   // Message for GUI if validator return false
                                   // If is empty, then check function will
                                   // return `Invalid value for "@{variable}"`
        required: false,           // If true, then value should be provided
        validator: (v, sett) => {  // Validate provided value (or default value)
          return v.length>0},      // (may use values of the other settings)
        editable: (v, sett) => {   // Check if option may be edited (if is
            return v.length>0},    // false, then only owner can change it)
                                   // (may use values of the other settings)
        enabled: (v, sett) => {    // Check if option is actual
          return v.length>0},      // (may use values of the other settings)
        default: (v, sett) =>      // Will be set, if value isn't provided
          'x',                     // (may use values of the other settings)
        isPassword: false          // additional option for passwords
    }
    // , other options go here
}



// WEBPACK FOOTER //
// ./src/settings/Settings.js